import React, { useContext, useEffect, useState } from 'react';
import MainMenu from '../../components/mainmenu';
import Footer from '../../components/mainfooter';

import { Context } from '../../AppContext';
import { ContextUI } from '../../uiContext';
import NewsView from '../../components/news/home-view';
import NewsViewItem from '../../components/news/home-view-item';
import OrganisationsView from '../../components/organisations/home-view';
import SurveyView from '../../components/module-survey/home-view';
const Home = (props) => {
    const context = useContext(Context);
    const contextUI = useContext(ContextUI);
    const [viewNews,setViewNews] = useState();

    useEffect(() => {
        if(props && props.match && props.match.params && props.match.params.id)
        setViewNews(props.match.params.id);
    }
    , []);
   
    if(viewNews){
        return (
            <>
                <MainMenu history={props.history} />
                <br/><br/>
                <NewsViewItem history={props.history} id={viewNews} />
                <br/><br/> <br/><br/> <br/><br/>
                <Footer />
            </>
        );
    }

    return (
        <>
            <MainMenu history={props.history} />
            <br/><br/>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' ,alignItems:'flex-start'}}>
                <OrganisationsView history={props.history} />
                <NewsView history={props.history}  />
                <SurveyView history={props.history} />
            </div>
            <br/><br/> <br/><br/> <br/><br/>
            <Footer />
        </>
    );
};

export default Home;